import {
  REQUEST_API_USAGE,
  REQUEST_API_USAGE_ERROR,
  RECEIVE_API_USAGE
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: REQUEST_API_USAGE,
  failure: REQUEST_API_USAGE_ERROR,
  receive: RECEIVE_API_USAGE
})

export default function (state = {}, { type, payload = {} }) {
  switch (type) {
    case REQUEST_API_USAGE:
    case REQUEST_API_USAGE_ERROR:
    case RECEIVE_API_USAGE:
      const { workspaceSlug } = payload
      return {
        ...state,
        [workspaceSlug]: reducer(state[workspaceSlug], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/legacy-api-usage.js